/**
 * Function to return trackEmailSignup analytics info
 */
export const trackEmailSignup = () => ({
    event: 'email subscribe',
    effect: 'campaign click',
});
